import axios from 'axios';

export const downloadService = {
    download,
};

// El mensaje de error de una descarga pedida con responseType "blob": el
// backend responde {"error": "..."} en JSON, pero axios lo entrega como Blob.
// Devuelve una promesa con ese texto, o con porDefecto si no se puede leer.
export function mensajeDeErrorDescarga(error, porDefecto) {
    const datos = error && error.response && error.response.data;
    if (!(datos instanceof Blob)) {
        return Promise.resolve(porDefecto);
    }
    return datos
        .text()
        .then((texto) => JSON.parse(texto).error || porDefecto)
        .catch(() => porDefecto);
}

function download(url, name) {
    axios({
      url: url,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", name);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
}

